import { render, staticRenderFns } from "./AreaInteresse.vue?vue&type=template&id=0451dc44&scoped=true"
import script from "./AreaInteresse.vue?vue&type=script&lang=js"
export * from "./AreaInteresse.vue?vue&type=script&lang=js"
import style0 from "./AreaInteresse.vue?vue&type=style&index=0&id=0451dc44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0451dc44",
  null
  
)

export default component.exports